import constants from '@/constants';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getFeatureSwitch']),

    isConcurrentEmploymentActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.CONCURRENT_EMPLOYMENT);
    },
  },
};
